var exports = {
  "kL": "x52a3aa3b--1f7cf5--container",
  "my": "x52a3aa3b--1f7cf5--avatar",
  "cK": "x52a3aa3b--1f7cf5--user-name",
  "Pf": "x52a3aa3b--1f7cf5--label",
};

module.exports = exports;
